"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PlusIcon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PlusIcon_svg__PlusIcon_svg__clip0_20663_110292)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "PlusIcon_svg__a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 13,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3H2v13h13V3z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#PlusIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.5a6.5 6.5 0 11-4.49-6.183L9.028 7.875H4.702L4.173 9.5H8.5l-1.267 3.9H9.02l1.268-3.9H15zm-.205-1.625h-3.98l1.241-3.817a6.51 6.51 0 012.74 3.817z",
    fill: "url(#PlusIcon_svg__PlusIcon_svg__paint0_linear_20663_110292)"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PlusIcon_svg__PlusIcon_svg__paint0_linear_20663_110292",
    x1: 2,
    y1: 8.633,
    x2: 15,
    y2: 8.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EB469F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8341EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PlusIcon_svg__PlusIcon_svg__clip0_20663_110292"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 3)",
    d: "M0 0h13v13H0z"
  }))));
};

exports.PlusIcon = PlusIcon;
var _default = PlusIcon;
exports.default = _default;